<div class="modal-header">
    <h4 class="modal-title">Müşteri Onayı Gönder</h4>
</div>
<div class="modal-body">
    <form [formGroup]="customerConfimrMailForm">
        <div class="col-12">
            <label>E-mail</label>
            <div class="form-group">
                <input type="email" class="form-control" id="email" formControlName="email" />
                <span
                    *ngIf="customerConfimrMailForm.get('email').invalid && customerConfimrMailForm.get('email').touched"
                    class="text-danger">
                    Mail zorunludur.
                </span>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="customerConfimrMailForm.invalid" (click)="sendEmail()">
        Gönder
    </button>
</div>